import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useMe } from "@/context/MeContext";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const { me } = useMe();
  const key = me ? `darna_cart_${me.user_id}` : null;
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!key) {
      setItems([]);
      return;
    }
    try {
      setItems(JSON.parse(localStorage.getItem(key)) || []);
    } catch {
      setItems([]);
    }
  }, [key]);

  const save = (next) => {
    setItems(next);
    if (key) localStorage.setItem(key, JSON.stringify(next));
  };

  const add = (product, withInstallation) => {
    const idx = items.findIndex((i) => i.product.id === product.id && i.with_installation === withInstallation);
    if (idx >= 0) {
      const next = [...items];
      next[idx] = { ...next[idx], qty: Math.min(20, next[idx].qty + 1) };
      save(next);
    } else save([...items, { product, qty: 1, with_installation: withInstallation }]);
  };
  const setQty = (i, qty) => save(items.map((it, k) => (k === i ? { ...it, qty: Math.max(1, Math.min(20, qty)) } : it)));
  const remove = (i) => save(items.filter((_, k) => k !== i));
  const clear = () => save([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.product.price * i.qty, 0);
    const installation = items.reduce((s, i) => s + (i.with_installation ? i.product.installation_fee * i.qty : 0), 0);
    return { subtotal, installation, total: subtotal + installation, count: items.reduce((s, i) => s + i.qty, 0) };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, totals, open, setOpen }}>{children}</CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
